import React, {useState}      from 'react'
import {Inertia}              from "@inertiajs/inertia";
import {PLANS}                from "@/Enums/plans";
import {FormError, Formheader} from "@/Components";
import {Tag}                  from "@/Components/Tag";
import { ToggleSwitch }       from "@/Components/Form";

export function OrganizationSettings({
  errors,
  organization,
  setAccordionHeading
}) {

  const errorBagKey = 'updateOrganization.' + organization.id;

  const [dirty, setDirty] = useState(false);
  const [organizationRequest, setOrganizationRequest] = useState({
    // email: organization.email || '',
    // phone: organization.phone || '',
    // organization_number: organization.organization_number || '',
    // name: organization.name || '',
    // user_firstname: organization.user_firstname || '',
    // user_surname: organization.user_surname || '',
    // user_email: organization.user_email || '',
    // comment: organization.comment || '',
    plan: organization.plan || PLANS.LIGHT,
    locked: !!(organization.locked_at) || false
  });

  function handleFormUpdate(e) {
    setDirty(true);
    const new_req = { ...organizationRequest };
    new_req[e.target.name] = e.target.value;
    setOrganizationRequest(new_req);
  }

  function handleOrganizationLocked() {
    setDirty(true);
    const new_req = { ...organizationRequest };
    new_req.locked = !new_req.locked;
    setOrganizationRequest(new_req);
  }

  function handleUpdate() {
    Inertia.put(`/admin/organization/${organization.id}`, organizationRequest, {
      preserveScroll: true,
      onSuccess: () => {
        setAccordionHeading(<>{organization.organization_number} <Tag className="ml-4">{organizationRequest.plan}</Tag></>, false);
        setDirty(false);
      }
    });
  }

  function SaveButton() {
    let disabled = false

    if (!dirty) {
      disabled = true
    }

    return <button
      disabled={disabled}
      onClick={handleUpdate}
      className="self-end ml-3 btn"
    >
      Save changes
    </button>
  }

  return (
    <>
      <div className="mb-4 pb-5 border-b">
        <Formheader>Organization details</Formheader>

        <h5 className="font-bold my-2 w-full">Name</h5>
        <p>{organization.name}</p>
        <h5 className="font-bold my-2 w-full">Organization number</h5>
        <p>{organization.organization_number}</p>

        {organization.comment && (<>
          <h5 className="font-bold my-2 w-full">Comment</h5>
          <p>{organization.comment}</p>
        </>)}

      </div>
      <div className="mb-4 pb-5 border-b">
        <Formheader>Contact details</Formheader>
        <h5 className="font-bold my-2 w-full">Email</h5>
        <p>{organization.email}</p>
        <h5 className="font-bold my-2 w-full">Phone</h5>
        <p>{organization.phone}</p>
      </div>

      <form className="w-full mb-4">
        <span className="block mb-1">Billing plan option</span>

        <label className="mr-4">
          <input
            checked={organizationRequest.plan === PLANS.LIGHT}
            value={PLANS.LIGHT}
            type="radio"
            name="plan"
            onChange={handleFormUpdate}
          />
          <span className="ml-2">Emma Light</span>
        </label>

        <label className="mr-4">
          <input
            checked={organizationRequest.plan === PLANS.CUSTOM}
            value={PLANS.CUSTOM}
            type="radio"
            name="plan"
            onChange={handleFormUpdate}
          />
          <span className="ml-2">Emma Custom</span>
        </label>
        <FormError error={errors && errors[errorBagKey]?.plan} />

        <div className="mt-4 pt-5 border-t">
          <span className="block mb-1">Lock organization</span>
          <ToggleSwitch checked={organizationRequest.locked} onChange={handleOrganizationLocked} />
          {organization?.locked_at && <span className="ml-2 text-sm2">Locked at {organization.locked_at}</span>}
        </div>
      </form>

      <div className="flex flex-row justify-end">
          <SaveButton/>
      </div>
    </>
  )
}
